import { parseIntOrNaN } from '@office-start/config-query-wrapper-service';
import { FileType } from '@office-start/document-types';
export function resolveUploadConfig(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    var featureSettings = _a.featureSettings;
    // FeatureSettings parsing
    var discreteChunkSizeInBytes = parseIntOrNaN((_b = featureSettings.upload) === null || _b === void 0 ? void 0 : _b.discreteChunkSizeInBytes);
    var fragmentTimeoutInMs = parseIntOrNaN((_c = featureSettings.upload) === null || _c === void 0 ? void 0 : _c.fragmentTimeoutInMilliseconds);
    var initialFragmentDivisor = parseIntOrNaN((_d = featureSettings.upload) === null || _d === void 0 ? void 0 : _d.initialFragmentDivisor);
    var initialWaitDurationInMs = parseIntOrNaN((_e = featureSettings.upload) === null || _e === void 0 ? void 0 : _e.initialWaitDurationInMilliseconds);
    var maxFragmentDivisor = parseIntOrNaN((_f = featureSettings.upload) === null || _f === void 0 ? void 0 : _f.maxFragmentDivisor);
    var maxFragmentSize = parseIntOrNaN((_g = featureSettings.upload) === null || _g === void 0 ? void 0 : _g.maxFragmentSizeInBytes);
    var maxWaitDurationInMs = parseIntOrNaN((_h = featureSettings.upload) === null || _h === void 0 ? void 0 : _h.maxWaitDurationInMilliseconds);
    var minFragmentSize = parseIntOrNaN((_j = featureSettings.upload) === null || _j === void 0 ? void 0 : _j.minFragmentSizeInBytes);
    var numClientAttempts = parseIntOrNaN((_k = featureSettings.upload) === null || _k === void 0 ? void 0 : _k.numAttemptsOnClientError);
    var numServerAttempts = parseIntOrNaN((_l = featureSettings.upload) === null || _l === void 0 ? void 0 : _l.numAttemptsOnServerError);
    var simpleUploadMaxSize = parseIntOrNaN((_m = featureSettings.upload) === null || _m === void 0 ? void 0 : _m.simpleUploadMaxSize);
    var slowDowngradeDivisor = parseIntOrNaN((_o = featureSettings.upload) === null || _o === void 0 ? void 0 : _o.slowDowngradeDivisor);
    var downgradeDivisor = parseIntOrNaN((_p = featureSettings.upload) === null || _p === void 0 ? void 0 : _p.downgradeDivisor);
    var slowFragmentTimeoutMultiplier = parseIntOrNaN((_q = featureSettings.upload) === null || _q === void 0 ? void 0 : _q.slowFragmentTimeoutMultiplier);
    var standardWaitDurationInMs = parseIntOrNaN((_r = featureSettings.upload) === null || _r === void 0 ? void 0 : _r.standardWaitDurationInMilliseconds);
    var upgradePowerDivisor = parseIntOrNaN((_s = featureSettings.upload) === null || _s === void 0 ? void 0 : _s.upgradePowerDivisor);
    return {
        discreteChunkSize: discreteChunkSizeInBytes,
        editableFileTypes: new Set([
            FileType.Excel,
            FileType.Word,
            FileType.PowerPoint,
        ]),
        fragmentTimeoutInMs: fragmentTimeoutInMs,
        initialSpeed: 1 / initialFragmentDivisor,
        initialWaitDurationInMs: initialWaitDurationInMs,
        maxFragmentSize: maxFragmentSize,
        maxWaitDurationInMs: maxWaitDurationInMs,
        minFragmentSize: minFragmentSize,
        minSpeed: 1 / maxFragmentDivisor,
        numClientAttempts: numClientAttempts,
        numServerAttempts: numServerAttempts,
        simpleUploadMaxSize: simpleUploadMaxSize,
        slowFragmentTimeoutMultiplier: slowFragmentTimeoutMultiplier,
        slowSpeedDowngradeRatio: 1 / slowDowngradeDivisor,
        speedDowngradeRatio: 1 / downgradeDivisor,
        speedUpgradeRatio: Math.pow(2, 1 / upgradePowerDivisor),
        standardWaitDurationInMs: standardWaitDurationInMs,
        uploadFileTypes: new Set([
            FileType.Excel,
            FileType.Word,
            FileType.Pdf,
            FileType.PowerPoint,
            FileType.Visio,
            FileType.Stream,
        ]),
    };
}
//# sourceMappingURL=resolveUploadConfig.js.map